import { Text, View } from "@react-pdf/renderer";
import styles from '../styles/styles';
import Element from "./element";

interface StandAndHarvestProps {
  labels: {
    header: string;
    undergrowthInOldForest: string;
    unevenAgedFoliage: string;
    activity: string;
    regeneration: string;
    expertReview: string;
    appendix16Value: string;
    appendix25Value: string;
    forestryEvaluation: string;
    forestryEvaluationAssessment: string;
  };
  data: {
    undergrowthInOldForest: string | null | undefined;
    unevenAgedFoliage: string | null | undefined;
    activity: string | null | undefined;
    regeneration: string | null | undefined;
    expertReview: string | null | undefined;
    appendix16Value: string | null | undefined;
    appendix25Value: string | null | undefined;
    forestryEvaluation: string | null | undefined;
    forestryEvaluationAssessment: string | null | undefined;
    category: string | undefined;
  };
}

const StandAndHarvest = ({ labels, data }: StandAndHarvestProps) => {
  if (data.category === "forest") {
    // Forest
    return (
      <>
        <View style={styles.row}>
          <Text style={styles.subHeader}>{labels.header}</Text>
        </View>

        {/* -- Undergrowth In Old Forest & UnevenAged Foliage-- */}
        {(data.undergrowthInOldForest !== undefined || data.unevenAgedFoliage !== undefined) && <>
          <View style={styles.miniSpacer} />

          <View style={styles.row}>
            {data.undergrowthInOldForest !== undefined && <Element label={labels.undergrowthInOldForest} data={data.undergrowthInOldForest} />}
            {data.unevenAgedFoliage !== undefined && <Element label={labels.unevenAgedFoliage} data={data.unevenAgedFoliage} />}

            {(data.undergrowthInOldForest === undefined || data.unevenAgedFoliage === undefined) && <View style={styles.column} />}
            <View style={styles.column} />
            <View style={styles.column} />
          </View>
        </>}

        {/* -- Regeneration -- */}
        {data.regeneration !== undefined && <>
          {/* 1 */}
          <View style={styles.miniSpacer} />

          <View style={styles.row}>
            <Element label={labels.activity} data={data.activity} />
            <Element label={labels.regeneration} data={data.regeneration} />

            <View style={styles.column} />
            <View style={styles.column} />
          </View>

          {/* 2 */}
          {data.expertReview !== undefined && <>
            <View style={styles.miniSpacer} />

            <View style={styles.row}>
              <View style={styles.column} />

              <Element label={labels.expertReview} data={data.expertReview} />
              {data.appendix16Value !== undefined && <Element label={labels.appendix16Value} data={data.appendix16Value} />}

              {data.appendix16Value === undefined && <View style={styles.column} />}
              <View style={styles.column} />
            </View>
          </>}
        </>}

        {/* -- Not Regeneration -- */}
        {data.regeneration === undefined && <>
          {/* 1 */}
          <View style={styles.miniSpacer} />

          <View style={styles.row}>
            <Element label={labels.activity} data={data.activity} />
            <Element label={labels.expertReview} data={data.expertReview} />
            {data.appendix16Value !== undefined && <Element label={labels.appendix16Value} data={data.appendix16Value} />}

            {data.appendix16Value === undefined && <View style={styles.column} />}
            <View style={styles.column} />
          </View>
        </>}

        {/* 2 / 3 */}
        {data.forestryEvaluation !== undefined && <>
          <View style={styles.miniSpacer} />

          <View style={styles.row}>
            <View style={styles.column} />

            <Element label={labels.forestryEvaluation} data={data.forestryEvaluation} />

            {data.forestryEvaluationAssessment !== undefined && (
              <Element
                label={labels.forestryEvaluationAssessment}
                data={data.forestryEvaluationAssessment}
              />
            )}

            {data.forestryEvaluationAssessment === undefined && <View style={styles.column} />}
            <View style={styles.column} />
          </View>
        </>}
      </>
    );
  } else {
    return (
      // Non Forest
      <>
        <View style={styles.row}>
          <Text style={styles.subHeader}>{labels.header}</Text>
        </View>

        {/* -- Appendix 25 -- */}
        {data.appendix25Value !== undefined && <>
          {/* 1 */}
          <View style={styles.miniSpacer} />

          <View style={styles.row}>
            <Element label={labels.activity} data={data.activity} />
            <Element label={labels.appendix25Value} data={data.appendix25Value} />

            <View style={styles.column} />
            <View style={styles.column} />
          </View>

          {/* 2 */}
          {data.regeneration !== undefined && <>
            <View style={styles.miniSpacer} />

            <View style={styles.row}>
              <View style={styles.column} />

              <Element label={labels.regeneration} data={data.regeneration} />

              <View style={styles.column} />
              <View style={styles.column} />
            </View>
          </>}
        </>}

        {/* -- Not Appendix 25 -- */}
        {data.appendix25Value === undefined && <>
          {/* 1 */}
          <View style={styles.miniSpacer} />

          <View style={styles.row}>
            <Element label={labels.activity} data={data.activity} />
            <Element label={labels.regeneration} data={data.regeneration} />

            <View style={styles.column} />
            <View style={styles.column} />
          </View>
        </>}
      </>
    );
  }
}

export default StandAndHarvest;
